import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentUploadComponent } from './document-upload/document-upload.component';
import { BorrowerDocumentComponent } from './borrower-document/borrower-document.component';
import { MatButtonModule } from '@angular/material/button';
// import { DropzoneCdkModule } from '@ngx-dropzone/cdk'
// import { DropzoneMaterialModule } from '@ngx-dropzone/material';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ProfileImgDialogComponent } from './profile-img-dialog/profile-img-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { FileViewerComponent } from './file-viewer/file-viewer.component';
import { ApprovedLoanDocumentComponent } from './approved-loan-document/approved-loan-document.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CurrencyMaskDirective } from './currency-mask/currency-mask.directive';
import { CurrencyPipe } from '@angular/common';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatExpansionModule,
        NgxDropzoneModule,
        // DropzoneCdkModule,
        // DropzoneMaterialModule,
        MatTableModule,
        MatIconModule,
        MatTooltipModule,
        MatButtonModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        
    ],
    providers: [CurrencyPipe],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        BorrowerDocumentComponent,
        ProfileImgDialogComponent,
        FileViewerComponent,
        ApprovedLoanDocumentComponent,
        CurrencyMaskDirective,
        ConfirmDialogComponent
    ],
    declarations: [
      DocumentUploadComponent,
      BorrowerDocumentComponent,
      ProfileImgDialogComponent,
      FileViewerComponent,
      ApprovedLoanDocumentComponent,
      CurrencyMaskDirective,
      ConfirmDialogComponent
    ]
})
export class SharedModule
{
}
